﻿import viewportSize from "./viewport-size";

const viewportChecker = (() => {
    function isXXL() {
        return window.matchMedia("(min-width: 1400px)").matches;
    }

    function isXL() {
        return window.matchMedia("(min-width: 1200px) and (max-width: 1399px)").matches;
    }

    function isLG() {
        return window.matchMedia("(min-width: 992px) and (max-width: 1199px)").matches;
    }

    function isMD() {
        return window.matchMedia("(min-width: 768px) and (max-width: 991px)").matches;
    }

    function isSM() {
        return window.matchMedia("(min-width: 576px) and (max-width: 767px)").matches;
    }

    function isXS() {
        return window.matchMedia("(max-width: 575px)").matches;
    }

    function isViewportGreaterThanOrEqualTo(size) {
        switch (size) {
            case viewportSize.xxl:
                return isXXL();
            case viewportSize.xl:
                return isXL() || isXXL();
            case viewportSize.lg:
                return isLG() || isXL() || isXXL();
            case viewportSize.md:
                return isMD() || isLG() || isXL() || isXXL();
            case viewportSize.sm:
                return isSM() || isMD() || isLG() || isXL() || isXXL();
            case viewportSize.xs:
                return true;
            default:
                return false;
        }
    }

    function isViewportGreaterThan(size) {
        switch (size) {
            case viewportSize.xxl:
                return false;
            case viewportSize.xl:
                return isXXL();
            case viewportSize.lg:
                return isXL() || isXXL();
            case viewportSize.md:
                return isLG() || isXL() || isXXL();
            case viewportSize.sm:
                return isMD() || isLG() || isXL() || isXXL();
            case viewportSize.xs:
                return isSM() || isMD() || isLG() || isXL() || isXXL();
            default:
                return false;
        }
    }

    function isViewportLessThanOrEqualTo(size) {
        switch (size) {
            case viewportSize.xxl:
                return true;
            case viewportSize.xl:
                return isXS() || isSM() || isMD() || isLG() || isXL();
            case viewportSize.lg:
                return isXS() || isSM() || isMD() || isLG();
            case viewportSize.md:
                return isXS() || isSM() || isMD();
            case viewportSize.sm:
                return isXS() || isSM();
            case viewportSize.xs:
                return isXS();
            default:
                return false;
        }
    }

    function isViewportLessThan(size) {
        switch (size) {
            case viewportSize.xxl:
                return isXS() || isSM() || isMD() || isLG() || isXL();
            case viewportSize.xl:
                return isXS() || isSM() || isMD() || isLG();
            case viewportSize.lg:
                return isXS() || isSM() || isMD();
            case viewportSize.md:
                return isXS() || isSM();
            case viewportSize.sm:
                return isXS();
            case viewportSize.xs:
                return false;
            default:
                return false;
        }
    }


    return {
        isViewportGreaterThanOrEqualTo: isViewportGreaterThanOrEqualTo,
        isViewportGreaterThan: isViewportGreaterThan,
        isViewportLessThanOrEqualTo: isViewportLessThanOrEqualTo,
        isViewportLessThan: isViewportLessThan,

        getViewportSize: function () {
            if (isXS()) {
                return viewportSize.xs;
            }
            if (isSM()) {
                return viewportSize.sm;
            }
            if (isMD()) {
                return viewportSize.md;
            }
            if (isLG()) {
                return viewportSize.lg;
            }
            if (isXL()) {
                return viewportSize.xl;
            }
            if (isXXL()) {
                return viewportSize.xxl;
            }

            // default
            return viewportSize.xs;
        }
    }
})();

// add functions to the window object so we can call them from other scripts
window.getViewportSize = viewportChecker.getViewportSize;

window.isViewportGreaterThanOrEqualTo = viewportChecker.isViewportGreaterThanOrEqualTo;
window.isViewportGreaterThan = viewportChecker.isViewportGreaterThan;
window.isViewportLessThanOrEqualTo = viewportChecker.isViewportLessThanOrEqualTo;
window.isViewportLessThan = viewportChecker.isViewportLessThan;


let exports = {
    getViewportSize: viewportChecker.getViewportSize,
    isViewportLessThanOrEqualTo: viewportChecker.isViewportLessThanOrEqualTo,
    isViewportLessThan: viewportChecker.isViewportLessThan,
    isViewportGreaterThanOrEqualTo: viewportChecker.isViewportGreaterThanOrEqualTo,
    isViewportGreaterThan: viewportChecker.isViewportGreaterThan
};

export const getViewportSize = viewportChecker.getViewportSize;
export const isViewportLessThanOrEqualTo = viewportChecker.isViewportLessThanOrEqualTo;
export const isViewportLessThan = viewportChecker.isViewportLessThan;
export const isViewportGreaterThanOrEqualTo = viewportChecker.isViewportGreaterThanOrEqualTo;
export const isViewportGreaterThan = viewportChecker.isViewportGreaterThan;